import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const CopyAltIcon: React.FC<OneColorIconProps> = ({ color = 'core-gray-600', className, size }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 17 20" fill="none" className={className}>
      <path
        d="M6 16C5.45 16 4.97917 15.8042 4.5875 15.4125C4.19583 15.0208 4 14.55 4 14V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H15C15.55 0 16.0208 0.195833 16.4125 0.5875C16.8042 0.979167 17 1.45 17 2V14C17 14.55 16.8042 15.0208 16.4125 15.4125C16.0208 15.8042 15.55 16 15 16H6ZM6 14H15V2H6V14ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4H2V18H13V20H2Z"
        fill={getHexColor(color)}
      />
    </svg>
  )
}
